import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/home.vue';

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((error) => error);
};

export const constRoutesPc = [
	{
		path: '/',
		name: 'en-home',
		meta: {
			appname: 'GB WhatsApp',
			title: 'GB WhatsApp: Features, Benefits, Risks & Download Guide',
			keywords: 'gb whatsapp, gb whatsapp download, gb whatsapp apk, gb whatsapp features, gb whatsapp risks',
			description:
				'Explore GB WhatsApp features, pros and cons, safety and account risks, then learn how to download and install the APK on Android.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gb-whatsapp.cc/',
				},
			],
		},
		component: Home,
	},
	{
		path: '/privacy-policy/',
		alias: '/privacy-policy',
		name: 'en-privacy-policy',
		meta: {
			appname: 'GB WhatsApp',
			title: 'Privacy Policy | gb-whatsapp.cc',
			keywords: 'gb whatsapp privacy policy',
			description:
				'Read how gb-whatsapp.cc handles basic website information, cookies, third-party links, and contact messages.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gb-whatsapp.cc/privacy-policy/',
				},
			],
		},
		props: {
			pageKey: 'privacy-policy',
		},
		component: () => import('@/views/compliance.vue'),
	},
	{
		path: '/disclaimer/',
		alias: '/disclaimer',
		name: 'en-disclaimer',
		meta: {
			appname: 'GB WhatsApp',
			title: 'Disclaimer | gb-whatsapp.cc',
			keywords: 'gb whatsapp disclaimer',
			description:
				'Important information about unofficial WhatsApp modifications and the independent role of gb-whatsapp.cc.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gb-whatsapp.cc/disclaimer/',
				},
			],
		},
		props: {
			pageKey: 'disclaimer',
		},
		component: () => import('@/views/compliance.vue'),
	},
	{
		path: '/about-us/',
		alias: '/about-us',
		name: 'en-about-us',
		meta: {
			appname: 'GB WhatsApp',
			title: 'About Us | gb-whatsapp.cc',
			keywords: 'about gb whatsapp guide',
			description:
				'Learn what gb-whatsapp.cc publishes and why this independent website only shares informational guides about GB WhatsApp.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gb-whatsapp.cc/about-us/',
				},
			],
		},
		props: {
			pageKey: 'about-us',
		},
		component: () => import('@/views/compliance.vue'),
	},
	{
		path: '/contact-us/',
		alias: '/contact-us',
		name: 'en-contact-us',
		meta: {
			appname: 'GB WhatsApp',
			title: 'Contact Us | gb-whatsapp.cc',
			keywords: 'contact gb whatsapp guide',
			description:
				'Contact the gb-whatsapp.cc information website by email at support@gb-whatsapp.cc.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gb-whatsapp.cc/contact-us/',
				},
			],
		},
		props: {
			pageKey: 'contact-us',
		},
		component: () => import('@/views/compliance.vue'),
	},
];

export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes: constRoutesPc,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition;
			}
			if (to.hash) {
				return { selector: to.hash };
			}
			return { x: 0, y: 0 };
		},
	});
}
